import { render } from "./LowStockReport.vue?vue&type=template&id=81a8038c&scoped=true"
import script from "./LowStockReport.vue?vue&type=script&lang=js"
export * from "./LowStockReport.vue?vue&type=script&lang=js"

import "./LowStockReport.vue?vue&type=style&index=0&id=81a8038c&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a8038c"]])

export default __exports__